import { put, select, takeLatest } from 'redux-saga/effects';
import {
  failure,
  request,
  success,
} from '../../reducers/comments/deleteCommentsSlice';
import { resetStateByEmail } from '../../reducers/comments/commentsSlice';
import { deleteDataByEmail } from '../../../firestore';

export function* deleteCommentsSaga({ payload: input }) {
  try {
    const { wMode } = yield select((state) => state.appConfig);

    const { email } = input;
    if (wMode === 'local') {
      yield put(resetStateByEmail({ email }));
      yield put(success());
      return;
    }

    const commentsFirestore = yield deleteDataByEmail('userComments', email);

    if (commentsFirestore.success) {
      yield put(resetStateByEmail({ email }));
      yield put(success());
      return;
    }

    throw new Error('error_delete_comments');
  } catch (error) {
    yield put(
      failure({
        message: error.message,
        status: error.message === 'error_delete_comments' ? 404 : 500,
      }),
    );
  }
}

export default function* deleteComments() {
  yield takeLatest(request, deleteCommentsSaga);
}
